/* sm-cart-drawer — slide-out cart. Client-rendered from /cart.js. Opens on: any add-to-cart (form submit,
   programmatic form.submit(), fetch/XHR to /cart/add), header cart icon, links to /cart. Closes on X,
   overlay, Escape. Body scroll lock, focus management, free-shipping progress, qty +/- / remove, upsell.
   Config comes from #sm-cart-config (emitted by sections/sm-header.liquid); sane defaults otherwise.
   Bundles: cart lines sharing properties._sm_bundle (added by sm-product-showcase) render as ONE row —
   no quantity stepper, one Remove that deletes every key in the bundle atomically via /cart/update.js. */
(function () {
  // Locale-aware store root, per Shopify's guidance ("avoid hardcoding URLs"): "/" on the
  // English site, "/es/" on the Spanish one. Cart calls made from it return localized data
  // (Spanish titles, /es/ product links) and keep the shopper in their language.
  function storeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  var root = document.querySelector('sm-cart-drawer');
  if (!root || root.dataset.smInit) return;
  root.dataset.smInit = '1';

  var cfg = {
    threshold: 7500,
    title: 'Cart',
    checkout: 'Check Out',
    emptyText: 'Your cart is empty.',
    continueText: 'Continue shopping',
    remaining: 'Spend {amount} more for Free Shipping',
    unlocked: "You've unlocked Free Shipping!",
    removeText: 'Remove item',
    moneyFormat: '${{amount}}',
    bundleUnit: 'jar',
    bundleFree: '{n} free',
    bundleSubscription: 'Autoship',
    freeLabel: 'FREE',
    bundleRemove: 'Remove',
    upsell: null
  };
  var cfgEl = document.getElementById('sm-cart-config');
  if (cfgEl) {
    try {
      var parsed = JSON.parse(cfgEl.textContent);
      Object.keys(parsed).forEach(function (k) {
        if (parsed[k] !== null && parsed[k] !== undefined && parsed[k] !== '') cfg[k] = parsed[k];
      });
      if (parsed.upsell === null) cfg.upsell = null;
    } catch (e) {
      /* keep defaults */
    }
  }
  cfg.noShipping = !cfg.threshold || cfg.threshold <= 0;
  if (cfg.noShipping) cfg.threshold = 1;
  // threshold is set in store currency (USD cents); the cart is in the shopper's currency
  try { var smRate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate); if (!cfg.noShipping && smRate > 0 && smRate !== 1) cfg.threshold = Math.round(cfg.threshold * smRate); } catch (e) {}
  (function () { var bar = root.querySelector('.sm-cart-drawer__shipping'); if (bar && cfg.noShipping) bar.setAttribute('hidden', ''); })();

  var q = function (sel) {
    return root.querySelector(sel);
  };
  var panel = q('.sm-cart-drawer__panel');
  var itemsEl = q('[data-sm-cart-items]');
  var emptyEl = q('[data-sm-cart-empty]');
  var emptyTextEl = q('[data-sm-cart-empty-text]');
  var continueEl = q('[data-sm-cart-continue]');
  var titleEl = q('[data-sm-cart-title]');
  var fillEl = q('[data-sm-cart-fill]');
  var shipTextEl = q('[data-sm-cart-shipping-text]');
  var subtotalEl = q('[data-sm-cart-subtotal]');
  var subtotalAmtEl = q('[data-sm-cart-subtotal-amount]');
  var subtotalCmpEl = q('[data-sm-cart-subtotal-compare]');
  var savePillEl = q('[data-sm-cart-save-pill]');
  var checkoutEl = q('[data-sm-cart-checkout]');
  var upsellEl = q('[data-sm-cart-upsell]');
  var reviewsEl = q('[data-sm-cart-reviews]');
  /* Review strip (static, from #sm-cart-config reviews): sits at the bottom of the scroll area, right above
     the subtotal. Quiet styling so the checkout button stays the only call to action. Auto-advances slowly. */
  (function buildReviews() {
    var list = (cfg.reviews || []).filter(function (r) { return r && r.image; }); // picture-led: photo reviews only
    if (!reviewsEl || !list.length) { reviewsEl = null; return; }
    var star = '<svg viewBox="0 0 16 15" width="13" height="13" aria-hidden="true"><path d="M8 .4l1.9 5.4 5.7.1-4.6 3.5 1.7 5.5L8 11.6l-4.7 3.3 1.7-5.5L.4 5.9l5.7-.1z" fill="currentColor"/></svg>';
    var stars = star + star + star + star + star;
    var check = '<svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true"><polygon points="8.00,0.80 9.58,2.11 11.60,1.76 12.31,3.69 14.24,4.40 13.89,6.42 15.20,8.00 13.89,9.58 14.24,11.60 12.31,12.31 11.60,14.24 9.58,13.89 8.00,15.20 6.42,13.89 4.40,14.24 3.69,12.31 1.76,11.60 2.11,9.58 0.80,8.00 2.11,6.42 1.76,4.40 3.69,3.69 4.40,1.76 6.42,2.11" fill="currentColor" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M5 8.3l2 2 4-4.1" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>'; // Instagram-style scalloped badge
    var avatars = list.slice(0, 3).map(function (r) { return '<img src="' + esc(r.image) + '" alt="" width="28" height="28">'; }).join('');
    reviewsEl.innerHTML =
      '<div class="sm-cart-drawer__reviews-top">' +
        (cfg.reviewsPill ? '<span class="sm-cart-drawer__reviews-pill"><span class="sm-cart-drawer__reviews-avatars">' + avatars + '</span><span>' + esc(cfg.reviewsPill) + '</span></span>' : '') +
        (cfg.reviewsHeading ? '<p class="sm-cart-drawer__reviews-heading">' + esc(cfg.reviewsHeading) + '</p>' : '') +
      '</div>' +
      '<div class="sm-cart-drawer__reviews-track">' + list.map(function (r) {
        var who = '<b>' + esc(r.name || '') + (r.age ? ', ' + esc(r.age) : '') + '</b>' + (r.flag ? ' <span class="sm-cart-drawer__review-flag">' + esc(r.flag) + '</span>' : '');
        var ba = !!r.imageAfter || !!r.combined; // two photos, or one photo that already contains before + after
        return '<figure class="sm-cart-drawer__review is-wide' + (ba ? ' is-ba' : '') + (r.combined ? ' is-combined' : '') + '">' +
          '<span class="sm-cart-drawer__review-media"><img src="' + esc(r.image) + '" alt="" loading="lazy" width="300" height="375">' +
            (ba ? (r.imageAfter ? '<img src="' + esc(r.imageAfter) + '" alt="" loading="lazy" width="300" height="375">' : '') +
                  (cfg.reviewsBefore ? '<span class="sm-cart-drawer__review-day is-before">' + esc(cfg.reviewsBefore) + '</span>' : '') +
                  (cfg.reviewsAfter ? '<span class="sm-cart-drawer__review-day is-after">' + esc(cfg.reviewsAfter) + '</span>' : '') : '') +
            '<span class="sm-cart-drawer__review-stars">' + stars + '</span></span>' +
          '<figcaption class="sm-cart-drawer__review-bar"><span class="sm-cart-drawer__review-bar-stars">' + stars + '</span><span>' + who + '</span>' +
            (r.verified !== false ? '<span class="sm-cart-drawer__review-verified">' + check + esc(cfg.reviewsVerified || 'Verified buyer') + '</span>' : '') +
          '</figcaption></figure>';
      }).join('') + '</div>';
    var track = reviewsEl.querySelector('.sm-cart-drawer__reviews-track');
    var paused = false;
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    if (!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) && list.length > 1) {
      setInterval(function () {
        if (paused || !root.classList.contains('is-open') || reviewsEl.hidden) return;
        var card = track.firstElementChild; if (!card) return;
        var step = card.getBoundingClientRect().width + 10;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
      }, 3500);
    }
  })();

  if (titleEl) titleEl.textContent = cfg.title;
  if (emptyTextEl) emptyTextEl.textContent = cfg.emptyText;
  if (continueEl) continueEl.textContent = cfg.continueText;
  if (checkoutEl) checkoutEl.textContent = cfg.checkout;

  var state = { cart: null, prevPct: 0, open: false, scrollY: 0, lastFocus: null, refreshing: null };
  var nativeFetch = window.fetch.bind(window);

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Money in the SHOPPER's currency. Liquid renders 1,234,567.89 through `money` in the active
  // currency (data-money-sample / moneySample); we copy its symbol, separators and decimals, so
  // €, S/, $U … all format and parse the way Shopify shows them. Falls back to the old format.
  var MS = (function (sample) {
    var m = sample && String(sample).match(/^([^\d]*)([\d][\d.,\s\u00a0\u202f'\u2019]*[\d])([^\d]*)$/);
    if (!m) return null;
    var core = m[2], digits = core.replace(/\D/g, '');
    var dec = digits.length === 9 ? 2 : 0;
    var decSep = dec ? core.charAt(core.length - 3) : '';
    var thouCore = dec ? core.slice(0, -3) : core;
    var t = thouCore.match(/\D/);
    return { pre: m[1], post: m[3], dec: dec, decSep: decSep, thou: t ? t[0] : '' };
  })(cfg.moneySample);
  function money(cents) {
    if (MS) {
      if (isNaN(cents) || cents == null) cents = 0;
      var n = (Math.round(cents) / 100).toFixed(MS.dec);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + MS.thou);
      var frac = parts[1] && parts[1] !== '00' ? MS.decSep + parts[1] : '';
      return MS.pre + whole + frac + MS.post;
    }
    var format = cfg.moneyFormat || '${{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    function fmt(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) number = 0;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }
    var v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    var out = format.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]+>/g, '');
    // match money_without_trailing_zeros used server-side
    return out.replace(/([.,])00(?!\d)/, '');
  }
  function imgSize(src, w) {
    if (!src) return '';
    try {
      var u = new URL(src, location.origin);
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u.href)) {
        u.searchParams.set('width', String(w));
        return u.href;
      }
      return src;
    } catch (e) {
      return src;
    }
  }
  var SPINNER = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="#F6BE00" stroke-width="2" stroke-linecap="round" stroke-dasharray="60" stroke-dashoffset="20"/></svg>';
  var ICON_MINUS = '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M0 4h8" stroke="currentColor" stroke-width="1.2"/></svg>';
  var ICON_PLUS = '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" aria-hidden="true"><path d="M4 0v8M0 4h8" stroke="currentColor" stroke-width="1.2"/></svg>';
  var ICON_STAR = '<svg viewBox="0 0 16 15" fill="none" aria-hidden="true"><path d="M8 0.411621L9.88091 5.82277L15.6085 5.93949L11.0434 9.40048L12.7023 14.8838L8 11.6116L3.29772 14.8838L4.95662 9.40048L0.391548 5.93949L6.11909 5.82277L8 0.411621Z" fill="#F6BE00"/></svg>';
  // Manukora: at quantity 1 the minus button becomes a trash can ("Remove item")
  var ICON_TRASH = '<svg width="8" height="9" viewBox="0 0 8 9" fill="none" aria-hidden="true"><path d="M.5 2h7M3 2V.9h2V2M1.4 2l.5 6.2h4.2L6.6 2M3.2 3.6v3.3M4.8 3.6v3.3" stroke="currentColor" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var ICON_TRASH_LG = '<svg width="12" height="13" viewBox="0 0 8 9" fill="none" aria-hidden="true"><path d="M.5 2h7M3 2V.9h2V2M1.4 2l.5 6.2h4.2L6.6 2M3.2 3.6v3.3M4.8 3.6v3.3" stroke="currentColor" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- render ---------- */
  function isBundleLine(item) {
    return !!(item && item.properties && item.properties._sm_bundle);
  }
  function hasBundle(cart) {
    return !!(cart && cart.items && cart.items.some(isBundleLine));
  }
  // Group cart lines by properties._sm_bundle, preserving cart order. Each entry keeps the real
  // 1-based line numbers so the stepper / change.js keep working for non-bundle lines.
  function groupCart(cart) {
    var entries = [], byId = {};
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      if (isBundleLine(item)) {
        var id = item.properties._sm_bundle;
        if (!byId[id]) { byId[id] = { type: 'bundle', id: id, items: [], lines: [] }; entries.push(byId[id]); }
        byId[id].items.push(item);
        byId[id].lines.push(line);
      } else {
        entries.push({ type: 'item', item: item, line: line });
      }
    });
    return entries;
  }
  function renderItem(item, line) {
    var vt = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var compareHtml = item.original_line_price > item.final_line_price ? '<s class="sm-cart-drawer__item-compare">' + money(item.original_line_price) + '</s>' : '';
    var minus = item.quantity <= 1
      ? '<button type="button" class="sm-cart-drawer__qty-btn sm-cart-drawer__qty-btn--minus is-remove" aria-label="' + esc(cfg.removeText) + '" data-line="' + line + '" data-qty="' + item.quantity + '">' + ICON_TRASH + '</button>'
      : '<button type="button" class="sm-cart-drawer__qty-btn sm-cart-drawer__qty-btn--minus" aria-label="' + esc(cfg.qtyDec || 'Decrease quantity') + '" data-line="' + line + '" data-qty="' + item.quantity + '">' + ICON_MINUS + '</button>';
    return (
      '<div class="sm-cart-drawer__item" data-line="' + line + '" data-key="' + esc(item.key) + '" data-product-id="' + item.product_id + '">' +
        '<a href="' + esc(item.url) + '" class="sm-cart-drawer__item-media" tabindex="-1" aria-hidden="true">' +
          (item.image ? '<img class="sm-cart-drawer__item-img" src="' + esc(imgSize(item.image, 180)) + '" alt="" loading="eager">' : '') +
        '</a>' +
        '<div class="sm-cart-drawer__item-body">' +
          '<div class="sm-cart-drawer__item-left">' +
            '<a href="' + esc(item.url) + '" class="sm-cart-drawer__item-title">' + esc(item.product_title) + '</a>' +
            (vt ? '<p class="sm-cart-drawer__item-variant">' + esc(vt) + '</p>' : '') +
          '</div>' +
          '<div class="sm-cart-drawer__item-right">' +
            '<div class="sm-cart-drawer__item-prices">' + compareHtml + '<span class="sm-cart-drawer__item-price">' + money(item.final_line_price) + '</span></div>' +
            '<div class="sm-cart-drawer__qty" role="group" aria-label="' + esc(cfg.qtyLabel || 'Quantity') + '">' + minus +
              '<span class="sm-cart-drawer__qty-num">' + item.quantity + '</span>' +
              '<button type="button" class="sm-cart-drawer__qty-btn sm-cart-drawer__qty-btn--plus" aria-label="' + esc(cfg.qtyInc || 'Increase quantity') + '" data-line="' + line + '" data-qty="' + item.quantity + '">' + ICON_PLUS + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }
  // Compare value of a bundle group: the PDP strike price stamped as _sm_bundle_compare, never
  // less than the sum of regular variant prices. Free jars count at full value, so 2+1 = $119.97.
  function bundleCompare(b) {
    var regular = 0;
    b.items.forEach(function (it) { regular += (it.original_price || it.price || 0) * (it.quantity || 0); });
    var cmp = parseInt(((b.items[0] || {}).properties || {})._sm_bundle_compare, 10) || 0;
    return regular > cmp ? regular : cmp;
  }
  function bundleFinal(b) {
    var fin = 0;
    b.items.forEach(function (it) { fin += it.final_line_price || 0; });
    return fin;
  }
  // Footer compare = sum of every line's strike value (bundle strike or compare_at); saving = compare − total,
  // so discount codes fold into the percent and the footer strike always equals the row strikes.
  // Mirrors the Liquid in snippets/sm-cart-drawer.liquid.
  function cartCompare(cart) {
    var compare = 0;
    groupCart(cart).forEach(function (e) {
      if (e.type === 'bundle') compare += bundleCompare(e);
      else compare += Math.max(e.item.original_line_price || 0, e.item.final_line_price || 0);
    });
    return compare;
  }
  function renderBundle(b) {
    var first = b.items[0];
    var props = first.properties || {};
    var unit = cfg.bundleUnit || 'jar';
    var sub = false, total = 0, free = 0;
    var rows = [], freeRows = [];
    b.items.forEach(function (it) {
      if (it.selling_plan_allocation) sub = true;
      var unitPrice = it.quantity ? Math.round(it.final_line_price / it.quantity) : 0;
      for (var i = 0; i < it.quantity; i++) {
        total += 1;
        var isFree = unitPrice === 0;
        if (isFree) free += 1;
        (isFree ? freeRows : rows).push('<li class="sm-cart-drawer__unit' + (isFree ? ' is-free' : '') + '"><span>1 ' + esc(unit) + '</span><span>' + (isFree ? esc(cfg.freeLabel || 'FREE') : money(unitPrice)) + '</span></li>');
      }
    });
    if (rows.length + freeRows.length > 1) {
      var sumTxt = total + ' ' + unit + (total === 1 ? '' : 's') + (free > 0 ? ' total' : '');
      rows = ['<li class="sm-cart-drawer__unit sm-cart-drawer__unit--summary">' +
              '<span>' + esc(sumTxt) + '</span><span></span></li>'];
      freeRows = [];
    }
    // A bundle variant is ONE cart line standing for several jars, so listing it as
    // "1 jar" is wrong. When the buybox supplied a subtitle, show that instead.
    if (props._sm_bundle_subtitle && b.items.length === 1) {
      rows = ['<li class="sm-cart-drawer__unit sm-cart-drawer__unit--summary"><span>' +
              esc(props._sm_bundle_subtitle) + '</span><span></span></li>'];
      freeRows = [];
    }
    var name = props._sm_bundle_name;
    if (!name) { var paid = total - free; name = free > 0 ? 'Buy ' + paid + ', Get ' + free + ' Free' : (total === 1 ? '1 ' + unit : total + ' ' + unit + 's'); }
    var title = props._sm_bundle_title || first.product_title || name;
    var img = props._sm_bundle_image || first.image;
    var bCompare = bundleCompare(b), bFinal = bundleFinal(b);
    return (
      '<div class="sm-cart-drawer__item sm-cart-drawer__item--bundle" data-bundle-id="' + esc(b.id) + '" data-key="' + esc(first.key) + '" data-product-id="' + first.product_id + '">' +
        '<a href="' + esc(first.url) + '" class="sm-cart-drawer__item-media" tabindex="-1" aria-hidden="true">' +
          (img ? '<img class="sm-cart-drawer__item-img" src="' + esc(props._sm_bundle_image ? img : imgSize(img, 180)) + '" alt="" loading="eager">' : '') +
        '</a>' +
        '<div class="sm-cart-drawer__item-body sm-cart-drawer__item-body--bundle">' +
          '<div class="sm-cart-drawer__item-top">' +
            '<a href="' + esc(first.url) + '" class="sm-cart-drawer__item-title">' + esc(title) + '</a>' +
            '<button type="button" class="sm-cart-drawer__bundle-remove" aria-label="' + esc(cfg.removeText) + '" data-sm-bundle-remove="' + esc(b.id) + '">' + ICON_TRASH_LG + '<span class="sm-cart-drawer__sr">' + esc(cfg.removeText) + '</span></button>' +
          '</div>' +
          '<div class="sm-cart-drawer__item-bottom">' +
            '<p class="sm-cart-drawer__item-variant">' + esc(name) +
              (total > 1 ? '<span class="sm-cart-drawer__item-perjar"> \u00b7 ' + esc(money(Math.round(bFinal / total)) + '/' + unit) + '</span>' : '') +
            '</p>' +
            '<div class="sm-cart-drawer__item-prices">' +
              '<span class="sm-cart-drawer__item-price">' + money(bFinal) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }
  function renderUpsell(cart) {
    if (!upsellEl) return;
    var u = cfg.upsell;
    var inCartQty = 0;
    if (u) {
      cart.items.forEach(function (i) {
        if (String(i.product_id) === String(u.productId) || String(i.variant_id) === String(u.variantId)) inCartQty += i.quantity;
      });
    }
    /* Default: hide once the upsell product is in the cart. allowSameProduct (second-jar upsell): keep
       showing until the shopper has 2+ of it. */
    var inCart = u && (u.allowSameProduct ? inCartQty >= 2 : inCartQty > 0);
    // A bundle already covers quantity — no "add a second jar" nudge next to it.
    if (!u || !cart.items.length || inCart || hasBundle(cart)) {
      upsellEl.setAttribute('hidden', '');
      upsellEl.innerHTML = '';
      return;
    }
    var price = '<p class="sm-cart-drawer__upsell-price">' + (u.comparePrice > u.price ? '<s>' + money(u.comparePrice) + '</s>' : '') + '<span>' + money(u.price) + '</span></p>';
    var reviews = u.rating
      ? '<span class="sm-cart-drawer__upsell-reviews"><span>' + ICON_STAR + ICON_STAR + ICON_STAR + ICON_STAR + ICON_STAR + '</span><span>' + esc(u.rating) + (u.reviewCount ? ' (' + esc(u.reviewCount) + ')' : '') + '</span></span>'
      : '';
    upsellEl.innerHTML =
      '<p class="sm-cart-drawer__upsell-note">' + ICON_STAR + '<span>' + esc(u.note) + '</span></p>' +
      '<div class="sm-cart-drawer__upsell-card">' +
        '<a href="' + esc(u.url) + '" class="sm-cart-drawer__upsell-media">' + (u.image ? '<img src="' + esc(imgSize(u.image, 300)) + '" alt="" loading="eager">' : '') + '</a>' +
        '<div class="sm-cart-drawer__upsell-content">' +
          '<div class="sm-cart-drawer__upsell-body">' +
            '<div><a href="' + esc(u.url) + '" class="sm-cart-drawer__upsell-title">' + esc(u.title) + '</a>' + reviews + (u.description ? '<p class="sm-cart-drawer__upsell-desc">' + esc(u.description) + '</p>' : '') + '</div>' +
            price.replace('sm-cart-drawer__upsell-price', 'sm-cart-drawer__upsell-price sm-cart-drawer__upsell-price--desktop') +
          '</div>' +
          '<div class="sm-cart-drawer__upsell-side">' +
            price.replace('sm-cart-drawer__upsell-price', 'sm-cart-drawer__upsell-price sm-cart-drawer__upsell-price--mobile') +
            '<button type="button" class="sm-cart-drawer__upsell-btn sm-btn sm-btn--outline sm-btn--sm" data-sm-upsell-add="' + u.variantId + '">' + esc(u.button) + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    upsellEl.removeAttribute('hidden');
  }
  function updateProgress(total, animate) {
    if (!fillEl || cfg.noShipping) return;
    var pct = Math.max(0, Math.min((total / cfg.threshold) * 100, 100));
    var remaining = cfg.threshold - total;
    fillEl.setAttribute('data-empty', pct <= 0 ? 'true' : 'false');
    if (animate) {
      fillEl.classList.add('no-animate');
      fillEl.style.width = state.prevPct + '%';
      void fillEl.offsetWidth;
      fillEl.classList.remove('no-animate');
      requestAnimationFrame(function () {
        fillEl.style.width = pct + '%';
      });
    } else {
      fillEl.style.width = pct + '%';
    }
    state.prevPct = pct;
    if (shipTextEl) shipTextEl.textContent = remaining > 0 ? cfg.remaining.replace('{amount}', money(remaining)) : cfg.unlocked;
  }
  /* Header bag stays in sync: the count badge and the empty/full icon are rendered once by Liquid,
     so every cart change has to push the new count back into the header. render() is the single
     choke point for adds, qty changes and removals, so syncing here covers all of them. */
  var lastHeaderCount = (function () {
    var el = document.querySelector('.sm-header__cart [data-sm-cart-count]');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isFinite(n) ? n : null;
  })();
  function bagCount(cart) {
    if (!cart || !cart.items) return 0;
    var seen = {}, n = 0;
    cart.items.forEach(function (it) {
      var id = it.properties && it.properties._sm_bundle;
      if (id) { if (!seen[id]) { seen[id] = 1; n += 1; } }
      else n += it.quantity || 0;
    });
    return n;
  }
  function syncHeader(cart) {
    var count = bagCount(cart);
    var each = function (sel, fn) { Array.prototype.forEach.call(document.querySelectorAll(sel), fn); };
    each('[data-sm-cart-count]', function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    each('.sm-header__cart', function (bag) {
      var empty = bag.querySelector('[data-sm-cart-empty]');
      var full = bag.querySelector('[data-sm-cart-full]');
      if (empty) { if (count > 0) empty.setAttribute('hidden', ''); else empty.removeAttribute('hidden'); }
      if (full) { if (count > 0) full.removeAttribute('hidden'); else full.setAttribute('hidden', ''); }
      var label = bag.getAttribute('aria-label');
      if (label) bag.setAttribute('aria-label', label.replace(/\(\s*\d+\s*\)\s*$/, '(' + count + ')'));
      if (lastHeaderCount !== null && count > lastHeaderCount) {
        bag.classList.remove('is-shaking');
        void bag.offsetWidth;
        bag.classList.add('is-shaking');
        setTimeout(function () { bag.classList.remove('is-shaking'); }, 1600);
      }
    });
    lastHeaderCount = count;
  }
  function render(cart, opts) {
    opts = opts || {};
    state.cart = cart;
    root.dataset.cartTotal = cart.total_price;
    root.dataset.itemCount = cart.item_count;
    syncHeader(cart);
    if (itemsEl) {
      itemsEl.innerHTML = groupCart(cart).map(function (e) {
        return e.type === 'bundle' ? renderBundle(e) : renderItem(e.item, e.line);
      }).join('');
    }
    if (emptyEl) {
      if (cart.items.length) emptyEl.setAttribute('hidden', '');
      else emptyEl.removeAttribute('hidden');
    }
    if (reviewsEl) {
      if (cart.items.length) reviewsEl.removeAttribute('hidden');
      else reviewsEl.setAttribute('hidden', '');
    }
    if (subtotalAmtEl) subtotalAmtEl.textContent = money(cart.total_price);
    else if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    var compare = cart.items.length ? cartCompare(cart) : 0;
    var saving = compare - cart.total_price;
    var pct = saving > 0 && compare > 0 ? Math.round(saving * 100 / compare) : 0;
    if (subtotalCmpEl) {
      if (saving > 0) { subtotalCmpEl.textContent = money(compare); subtotalCmpEl.removeAttribute('hidden'); }
      else subtotalCmpEl.setAttribute('hidden', '');
    }
    if (savePillEl) {
      if (pct > 0) { savePillEl.textContent = (cfg.savePct || 'Save __PCT__%').replace('__PCT__', pct); savePillEl.removeAttribute('hidden'); }
      else savePillEl.setAttribute('hidden', '');
    }
    if (checkoutEl) {
      if (cart.items.length) {
        checkoutEl.removeAttribute('aria-disabled');
        checkoutEl.removeAttribute('tabindex');
      } else {
        checkoutEl.setAttribute('aria-disabled', 'true');
        checkoutEl.setAttribute('tabindex', '-1');
      }
    }
    updateProgress(cart.total_price, state.open);
    renderUpsell(cart);
    document.dispatchEvent(new CustomEvent('sm-cart:updated', { detail: { cart: cart, added: !!opts.added } }));
  }

  /* ---------- data ---------- */
  function fetchCart() {
    return nativeFetch(storeRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }
  function refresh(cart, opts) {
    if (cart && cart.items) {
      render(cart, opts);
      return Promise.resolve(cart);
    }
    if (state.refreshing) return state.refreshing;
    state.refreshing = fetchCart()
      .then(function (c) {
        render(c, opts);
        return c;
      })
      .catch(function (e) {
        console.error('[sm-cart] refresh failed', e);
      })
      .finally(function () {
        state.refreshing = null;
      });
    return state.refreshing;
  }
  function parseError(data, fallback) {
    if (!data) return fallback;
    return data.description || data.message || (data.errors && (Array.isArray(data.errors) ? data.errors[0] : Object.values(data.errors)[0])) || fallback;
  }
  function showLoading(itemEl) {
    if (!itemEl) return;
    hideLoading(itemEl);
    var o = document.createElement('div');
    o.className = 'sm-cart-drawer__loading';
    o.innerHTML = SPINNER;
    itemEl.appendChild(o);
  }
  function hideLoading(itemEl) {
    if (!itemEl) return;
    var o = itemEl.querySelector('.sm-cart-drawer__loading');
    if (o) o.remove();
  }
  function showError(itemEl, msg) {
    if (!itemEl) return;
    var e = itemEl.querySelector('.sm-cart-drawer__item-error');
    if (!e) {
      e = document.createElement('p');
      e.className = 'sm-cart-drawer__item-error';
      itemEl.querySelector('.sm-cart-drawer__item-left').appendChild(e);
    }
    e.textContent = msg;
  }
  function changeLine(line, quantity) {
    var itemEl = itemsEl && itemsEl.querySelector('.sm-cart-drawer__item[data-line="' + line + '"]');
    showLoading(itemEl);
    return nativeFetch(storeRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(parseError(data, cfg.updateError || 'Could not update the cart.'));
          return data;
        });
      })
      .then(function (cart) {
        render(cart);
        document.dispatchEvent(new CustomEvent('sm-cart:changed', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function (err) {
        hideLoading(itemEl);
        showError(itemEl, err.message);
      });
  }
  // Atomic bundle delete (ported from legacy mj-cart-reconcile handleBundleDelete): one
  // /cart/update.js call with every key in the bundle at qty 0, so the customer never ends up
  // with a partial bundle and line keys can't shift between sequential change.js calls.
  function removeBundle(bundleId) {
    var itemEl = itemsEl && itemsEl.querySelector('.sm-cart-drawer__item[data-bundle-id="' + bundleId + '"]');
    showLoading(itemEl);
    var source = state.cart && state.cart.items ? Promise.resolve(state.cart) : fetchCart();
    return source
      .then(function (cart) {
        var updates = {};
        var removedLabel = '';
        cart.items.forEach(function (it) {
          if (isBundleLine(it) && it.properties._sm_bundle === bundleId) {
            updates[it.key] = 0;
            if (!removedLabel && it.properties._sm_bundle_name) removedLabel = it.properties._sm_bundle_name;
          }
        });
        if (!Object.keys(updates).length) return cart;
        track('sm_bundle_removed', { tier_label: removedLabel });
        return nativeFetch(storeRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(parseError(data, cfg.updateError || 'Could not update the cart.'));
            return data;
          });
        });
      })
      .then(function (cart) {
        render(cart);
        document.dispatchEvent(new CustomEvent('sm-cart:changed', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function (err) {
        hideLoading(itemEl);
        showError(itemEl, err.message);
      });
  }
  function add(payload) {
    return nativeFetch(storeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(parseError(data, cfg.addError || 'Could not add to cart.'));
        return refresh(null, { added: true }).then(function () {
          open();
          return data;
        });
      });
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (state.open) return;
    state.open = true;
    state.lastFocus = document.activeElement;
    state.scrollY = window.scrollY;
    root.removeAttribute('hidden');
    document.body.style.top = -state.scrollY + 'px';
    document.body.classList.add('sm-cart-open');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      updateProgress(state.cart ? state.cart.total_price : parseInt(root.dataset.cartTotal || '0', 10), true);
    });
    setTimeout(function () {
      var c = q('.sm-cart-drawer__close');
      (c || panel).focus({ preventScroll: true });
    }, 320);
    document.dispatchEvent(new CustomEvent('sm-cart:open'));
  }
  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    document.body.classList.remove('sm-cart-open');
    document.body.style.top = '';
    window.scrollTo(0, state.scrollY);
    setTimeout(function () {
      if (!state.open) root.setAttribute('hidden', '');
    }, 300);
    if (state.lastFocus && state.lastFocus.focus) {
      try { state.lastFocus.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    }
    document.dispatchEvent(new CustomEvent('sm-cart:close'));
  }

  /* ---------- funnel tracking (pixel source: analytics/funnel/) ---------- */
  // Offer names in the cart, one per bundle; the tracking server maps EN/ES names to tier 1/2/3.
  function cartTierLabels(cart) {
    var seen = {}, out = [];
    ((cart && cart.items) || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._sm_bundle && p._sm_bundle_name && !seen[p._sm_bundle]) { seen[p._sm_bundle] = 1; out.push(p._sm_bundle_name); }
    });
    return out;
  }
  function track(name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, data);
    } catch (e) { /* tracking must never break the cart */ }
  }

  /* ---------- events inside the drawer ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    // Best effort: the browser is already navigating to checkout, so this can occasionally be
    // lost. checkout_started (fired by Shopify on the checkout page) is the reliable signal.
    if (t.closest('[data-sm-cart-checkout]')) {
      track('sm_checkout_clicked', {
        cart_tier_labels: cartTierLabels(state.cart),
        value: state.cart ? state.cart.total_price / 100 : null
      });
    }
    if (t.closest('[data-sm-cart-close]')) {
      e.preventDefault();
      close();
      return;
    }
    var minus = t.closest('.sm-cart-drawer__qty-btn--minus');
    var plus = t.closest('.sm-cart-drawer__qty-btn--plus');
    var rm = t.closest('.sm-cart-drawer__remove');
    var bundleRm = t.closest('[data-sm-bundle-remove]');
    var up = t.closest('[data-sm-upsell-add]');
    if (bundleRm) {
      bundleRm.disabled = true;
      removeBundle(bundleRm.dataset.smBundleRemove).finally(function () { bundleRm.disabled = false; });
    } else if (minus || plus) {
      var b = minus || plus;
      var line = parseInt(b.dataset.line, 10);
      var qty = parseInt(b.dataset.qty, 10) || 1;
      changeLine(line, plus ? qty + 1 : Math.max(0, qty - 1));
    } else if (rm) {
      changeLine(parseInt(rm.dataset.line, 10), 0);
    } else if (up) {
      up.disabled = true;
      add({ items: [{ id: Number(up.dataset.smUpsellAdd), quantity: 1 }] })
        .catch(function (err) {
          console.error('[sm-cart]', err);
        })
        .finally(function () {
          up.disabled = false;
        });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') {
      // keep focus inside the panel
      var focusables = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- global wiring ---------- */
  // 1. header cart icon + any link to /cart
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sm-cart-open], a[href="/cart"], a[href$="/cart"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    open();
    refresh();
  }, true);

  // 2. plain add-to-cart forms (Horizon's <product-form-component> handles its own fetch; we catch that in #4)
  function formPayload(form) {
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
    var sp = fd.get('selling_plan');
    if (sp) item.selling_plan = Number(sp);
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = v;
    });
    if (Object.keys(props).length) item.properties = props;
    return { items: [item] };
  }
  function isAddForm(form) {
    return form instanceof HTMLFormElement && /\/cart\/add/.test(form.getAttribute('action') || '') && !form.closest('product-form-component');
  }
  function submitViaAjax(form) {
    var btn = form.querySelector('[type="submit"], button:not([type])');
    if (btn) btn.disabled = true;
    add(formPayload(form))
      .catch(function (err) {
        console.error('[sm-cart] add failed, falling back to native submit', err);
        nativeSubmit.call(form);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!isAddForm(f)) return;
    e.preventDefault();
    submitViaAjax(f);
  }, true);

  // 3. programmatic form.submit() (fires no submit event) — e.g. the current WonderScalp buybox
  var nativeSubmit = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (isAddForm(this)) {
      submitViaAjax(this);
      return;
    }
    return nativeSubmit.apply(this, arguments);
  };

  // 4. any other script that fetches /cart/add|change|update|clear (Horizon product forms, apps)
  var wrappedFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = wrappedFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) {
      var isAdd = /\/cart\/add/.test(url);
      p.then(function (res) {
        if (!res || !res.ok) return;
        refresh(null, { added: isAdd }).then(function () {
          if (isAdd) open();
        });
      }).catch(function () {});
    }
    return p;
  };
  // XHR fallback (older apps)
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) {
      var isAdd = /\/cart\/add/.test(url);
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          refresh(null, { added: isAdd }).then(function () {
            if (isAdd) open();
          });
        }
      });
    }
    return xhrOpen.apply(this, arguments);
  };

  // 5. Horizon theme events
  document.addEventListener('cart:update', function () {
    refresh();
  });

  window.SMCart = { open: open, close: close, refresh: refresh, add: add, changeLine: changeLine, removeBundle: removeBundle };

  // initial sync (Liquid rendered the shell; JS owns it from here)
  refresh();
})();
